import { render, staticRenderFns } from "./billing-modal-invoices-add-to.vue?vue&type=template&id=0c054820&scoped=true&"
import script from "./billing-modal-invoices-add-to.ts?vue&type=script&lang=ts&"
export * from "./billing-modal-invoices-add-to.ts?vue&type=script&lang=ts&"
import style0 from "./billing-modal-invoices-add-to.scss?vue&type=style&index=0&id=0c054820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c054820",
  null
  
)

export default component.exports